// Module
var code = "<treasure-overlay-spinner active=\"vm.spinner\"> <button class=\"outline\" ng-if=\"vm.isAgent && vm.activeSubscription\" ng-click=\"vm.onCancelRenewal($event)\" compliance-coach> Cancel renewal subscription </button> </treasure-overlay-spinner> ";
// Exports
var _module_exports = code;;
var path = 'app/directives/subscriptions/cancel-subscription/cancel-renewal-subscription.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;